module.exports = __webpack_public_path__ + "static/media/NathanDrake.a9a9836f.jpg";